import { BrowserRouter, Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Navbar from "./components/navbar/Navbar";
// import Home from "./components/home/Home";
import ContactUs from "./components/contactus/Contactus";
import TryNow from "./components/trynow/TryNow";
import Footer from "./components/footer/Footer";
import LoginForm from "./components/login/LoginForm";
// import TasksView from "./components/tasks/TasksView";
// import Tasks from "./components/tasks/Tasks";
import TranstionUpdate from "./components/tasks/TranstionUpdate";
import TasksList from "./components/tasks/TasksList";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Protected route wrapper
const ProtectedRoute = ({ isAuthenticated, children }) => {
  const location = useLocation();
  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

// Login component
const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Use the 'from' path from location.state, default to '/trynow' if not provided
  const from = location.state?.from?.pathname || "/trynow";

  const handleLogin = useCallback(
    (token) => {
      onLogin(token);
      navigate(from, { replace: true });
    },
    [onLogin, navigate, from]
  );

  return <LoginForm onLogin={handleLogin} />;
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // eslint-disable-next-line
  const [isAdmin, setIsAdmin] = useState(false);
  // eslint-disable-next-line
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogin = useCallback((token) => {
    localStorage.setItem("access_token", token);
    setIsAuthenticated(true);
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      setUserRole(payload.role);
      setIsAdmin(payload.role === "admin");
    } catch (err) {
      console.error("handleLogin: Token decode failed:", err);
      localStorage.removeItem("access_token");
      setIsAuthenticated(false);
      setUserRole(null);
      setIsAdmin(false);
    }
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("access_token");
    setIsAuthenticated(false);
    setUserRole(null);
    setIsAdmin(false);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        setIsAuthenticated(true);
        setUserRole(payload.role);
        setIsAdmin(payload.role === "admin");
      } catch (err) {
        console.error("useEffect: Token validation failed:", err);
        handleLogout(); // Invalid token
      }
    }
    setLoading(false);
  }, [handleLogout]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {isAuthenticated ? (
        <>
          <Navbar isAuthenticated={isAuthenticated} handleLogout={handleLogout} />
          <Routes>
            {/* <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Home />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <TryNow />
                </ProtectedRoute>
              }
            />
            {/* List / Table */}
            <Route
              path="/tasks"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <TasksList />           {/* Only the table */}
                </ProtectedRoute>
              }
            />

            {/* Edit Form */}
            <Route
              path="/tasks/edit/:taskId"   // or "/tasks/edit/:taskId"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <TranstionUpdate />   {/* Only the edit form */}
                </ProtectedRoute>
              }
            />
            <Route
              path="/contactus"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ContactUs />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}

    </BrowserRouter>
  );
};

export default App;